import { Box, Grid, Stack } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat } from '../../../helpers';
import {
  DrawerWidget,
  ModalComponent,
  SnackbarAlertWidget,
} from '../../../widgets';
import BotonFechasComponent from '../../accesos/components/BotonFechas';
import SwitchFechaComponent from '../../accesos/components/SwitchFecha';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allAsistenciasAction,
  setActivoAsistenciasAction,
} from './AsistenciasAction';
import { PARAMS_ASISTENCIAS_DIARIAS } from './AsistenciasReducer';
import FiltrosAsistenciasComponent from './components/FiltrosAsistencias';
import ListadoAsistencias from './components/ListadoAsistencias';
import TextFiltrosAsistenciasComponent from './components/TextFiltrosAsistencias';
import ReportesAsistencias from './reportes/ReportesAsistencias';

const AsistenciasView = () => {
  const dispatch = Redux.useDispatch();

  const asistenciasStore = Redux.useSelector((state) => state.asistencias);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);

  const [openModalReporte, setOpenModalReporte] = React.useState(false);
  const [isFiltros, setIsFiltros] = React.useState(false);
  const [isRango, setIsRango] = React.useState(false);
  const [isFuturo, setIsFuturo] = React.useState(true);

  React.useEffect(() => {}, [estudiantesStore.activo]);

  React.useEffect(() => setIsFiltros(isRango), [isRango]);

  const botonFecha = (
    <Stack direction="row" spacing={2} alignItems="center">
      <BotonFechasComponent
        futuro={isFuturo}
        dateRango={async (start, end) => {
          const payload = {
            ...asistenciasStore.params,
            desde: dateformat(start, {}),
            hasta: dateformat(end, {}),
          };
          dispatch({
            type: PARAMS_ASISTENCIAS_DIARIAS,
            payload,
          });
          await allAsistenciasAction(dispatch, payload);
        }}
        setIsRango={(e) => setIsRango(e)}
      />
      {asistenciasStore.params.desde !== asistenciasStore.params.hasta &&
        !isRango && (
          <SwitchFechaComponent
            value={isFuturo}
            onClickLeft={() => setIsFuturo(false)}
            onClickRigth={() => setIsFuturo(true)}
            onChange={(e) => setIsFuturo(e.target.checked)}
          />
        )}
    </Stack>
  );

  return (
    <Grid container spacing={1}>
      <SnackbarAlertWidget alert={asistenciasStore.alertView} />
      <Grid
        item
        md={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Box>
          <BotonComponent
            click={async () => {
              await setActivoAsistenciasAction(dispatch, null);
              await allAsistenciasAction(dispatch, asistenciasStore.params);
            }}
            disabled={
              asistenciasStore.loadingAll || asistenciasStore.all.length === 0
            }
            white
            text={
              asistenciasStore.loadingAll ? 'Actualizando...' : 'Actualizar'
            }
            refreshIcon
            mr={2}
          />
          <BotonComponent
            text="EXPORTAR PDF"
            click={() => setOpenModalReporte(true)}
            blue
            disabled={asistenciasStore.all.length === 0}
            downloadIcon
            mr={2}
          />
        </Box>
        <Stack direction="row" justifyContent="flex-end">
          {botonFecha}
          <BotonComponent
            text={`FILTROS ${isFiltros ? 'ACTIVO' : ''}`}
            filterIcon
            click={() => setIsFiltros(!isFiltros)}
            white={!isFiltros}
            blue={isFiltros}
            ml={2}
          />
        </Stack>
      </Grid>
      <Grid item md={12}>
        <TextFiltrosAsistenciasComponent />
        <ListadoAsistencias />
      </Grid>
      <DrawerWidget open={isFiltros} onClose={(val) => setIsFiltros(val)}>
        <FiltrosAsistenciasComponent />
      </DrawerWidget>
      <ModalComponent
        id="modalPdf"
        title="Reporte de accesos"
        open={openModalReporte}
        maxWidth="lg"
        onClose={() => setOpenModalReporte(!openModalReporte)}
      >
        <ReportesAsistencias />
      </ModalComponent>
    </Grid>
  );
};

export default AsistenciasView;
